import { IBrandData }         from '@core/services/brand/brand.interfaces';
import { TaxationScopesEnum } from '@models/scope.enums';


// ENUMS #######################################################################
export enum EnvironmentEnum {
	STABLE = 'stable',
	STAGING = 'staging',
	UNSTABLE = 'unstable',
}

export enum ENVIRONMENT_BASE_URL {
	DF_STABLE = 'https://fiskal.cloud',
	DF_STAGING = 'https://staging.fiskal.cloud',
	DF_UNSTABLE = 'https://unstable.fiskal.cloud',
	DF_UNSTABLE_OPS = 'https://unstable-ops.fiskal.cloud',
	DF_UNSTABLE_AKS = 'https://unstable-aks.unstable.gwc.fiskal.cloud',
	TEMPLATE_STABLE = 'https://template.com',							// Brand STABLE URL
	TEMPLATE_STAGING = 'https://staging.template.com',		// Brand STAGING URL
	TEMPLATE_UNSTABLE = 'https://unstable.template.com',	// Brand UNSTABLE URL
}


// INTERFACES ##################################################################
export interface IFeatureConfig {
	enabled: boolean;
}

export interface IElsterFeatureEnabled extends IFeatureConfig {
	enabled: true;
}

export interface IElsterFeatureDisabled extends IFeatureConfig {
	enabled: false;
	exceptedScopes: TaxationScopesEnum[];
}

export interface IEnvironmentConfig {
	activeEnvironment: EnvironmentEnum;
	brandData: IBrandData;
	devModules: any[];
	envBaseUrl: ENVIRONMENT_BASE_URL;
	features: {
		elster: ElsterFeatureConfig;
	};
	keycloak: IEnvironmentKeycloakConfig;
	production: boolean;
	unstableBaseUrl?: ENVIRONMENT_UNSTABLE_BASE_URL;
	useMockRequest?: boolean;
}

export interface IEnvironmentKeycloakConfig {
	url: string;

	realm: string;

	clientId: string;
}


// TYPES #######################################################################
export type ElsterFeatureConfig =
	IElsterFeatureDisabled
	| IElsterFeatureEnabled

export type ENVIRONMENT_UNSTABLE_BASE_URL =
	ENVIRONMENT_BASE_URL.DF_UNSTABLE |
	ENVIRONMENT_BASE_URL.TEMPLATE_UNSTABLE; // Brand Base URL



